import { filterNotEmpty } from 'src/utils/data/listHelpers';
import { DataTableObject } from './Objects.types';
import { GetObjectsQuery } from './__generated__/GetObjects.graphql';

export const convertObjectToDataTableObject = (data: GetObjectsQuery | undefined): DataTableObject[] => {
  const objects = filterNotEmpty(data?.customObjectDefinitions.customObjectDefinitions) ?? [];
  return objects.map((object) => {
    const { fields } = object;
    const notEmptyFields = filterNotEmpty(fields) ?? [];
    return {
      ...object,
      parentId: object.uid ?? '',
      uid: object.uid ?? '',
      subRows: notEmptyFields.map((field) => ({
        ...field,
        external: object.external || undefined,
        parentId: object.uid ?? '',
        uid: field.uid ?? '',
        subRows: []
      }))
    };
  });
};
